export function styleRule(styleId: string, css: string) {
  if (!css) return null;
  return <style href={styleId} precedence="default" dangerouslySetInnerHTML={{ __html: css }} />;
}
